import React, { createContext, useState, useContext } from 'react';

// Create context
const AuthContext = createContext(null);

// Auth provider component
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(false);

  // Login function
  const login = (username, password) => {
    // This is a placeholder - in a real app this would make an API call
    setLoading(true);
    
    setTimeout(() => {
      setCurrentUser({ username });
      setLoading(false);
    }, 1000);
  };

  // Logout function
  const logout = () => {
    setCurrentUser(null);
  };

  // Provider values
  const value = {
    currentUser,
    loading,
    login,
    logout
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Custom hook for using auth context
export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthContext; 